export const isAbsoluteUrl = (url: string) => /^(?:[a-z]+:)?\/\//.test(url);
